import { CheckFillIcon, FormActions, Modal, RoundElement, Text, Title } from 'ui';

type P = {
  onClose: () => void;
};

const SubscribeResult = ({ onClose }: P) => (
  <>
    <div className="subscribe-result">
      <RoundElement className="subscribe-result__icon" color="success" size="large">
        <CheckFillIcon type="success" />
      </RoundElement>
      <Title level={3} marginBottom>
        Order completeness was successful
      </Title>
      <Text>
        You successfully finished the order form. You will receive an e-mail when we will ship the Withings devices to
        your delivery address.
      </Text>
    </div>
    <Modal.HugContent.Footer>
      <FormActions right={{ children: 'Close', onClick: onClose }} />
    </Modal.HugContent.Footer>
  </>
);

export default SubscribeResult;
